__turbopack_context__.v({
  "hasSubItems": "categoryItem-module-scss-module__X3jcyW__hasSubItems",
  "iconWrapper": "categoryItem-module-scss-module__X3jcyW__iconWrapper",
  "item": "categoryItem-module-scss-module__X3jcyW__item",
  "itemIcon": "categoryItem-module-scss-module__X3jcyW__itemIcon",
  "itemName": "categoryItem-module-scss-module__X3jcyW__itemName",
  "itemTooltipContainer": "categoryItem-module-scss-module__X3jcyW__itemTooltipContainer",
  "itemTooltipWrp": "categoryItem-module-scss-module__X3jcyW__itemTooltipWrp",
  "row": "categoryItem-module-scss-module__X3jcyW__row",
});
